import { EyeOpenIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import { ToggleCameraPosesButton } from 'features/kestrelViewer/ui/tools/visibilityToggles/ToggleCameraPosesButton'
import { ToggleLabelsButton } from 'features/kestrelViewer/ui/tools/visibilityToggles/ToggleLabelsButton'
import { ToggleMeasureButton } from 'features/kestrelViewer/ui/tools/visibilityToggles/ToggleMeasureButton'
import React, { useState } from 'react'
import styled from 'styled-components'

const VisibilityTogglesContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const SubTogglesContainer = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  left: 100%;
  top: 0;
  display: flex;
  flex-direction: row;
  gap: 0px;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  transition: opacity 0.2s ease-in-out;
`

export const VisibilityTogglesSubmenu: React.FC = () => {
  const [showSubToggles, setShowSubToggles] = useState(false)

  return (
    <VisibilityTogglesContainer
      onMouseEnter={() => setShowSubToggles(true)}
      onMouseLeave={() => setShowSubToggles(false)}>
      <TooltipWrapper side='top' offset={5} label='Visibility Toggles'>
        <ViewToggle onClick={() => {}} hasSubmenu={true}>
          <EyeOpenIcon width={22} height={22} style={{ color: 'white' }} />
        </ViewToggle>
      </TooltipWrapper>

      <SubTogglesContainer $isVisible={showSubToggles}>
        <ToggleLabelsButton />
        <ToggleMeasureButton />
        <ToggleCameraPosesButton />
      </SubTogglesContainer>
    </VisibilityTogglesContainer>
  )
}
